import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

import { Icon } from 'components/Icon'
import { StatusBox } from 'components/StatusBox'
import { ModalDeleteGroupClient } from 'components/ClientGroup/ModalDeleteGroupClient/ModalDeleteGroupClient'

import { labels, statusBadgeClassnames } from 'constants/clientGroup.constants'

import { deleteClientGroup } from 'store/ClientGroup/ClientGroup.actions'
import { all } from 'store/ClientGroup/ClientGroup.selector'
import { useTranslation } from 'react-i18next'

import * as S from './styled'
import { theme } from 'config'
import { THEMES_NAME } from 'config/theme.config'

export function ClientGroupInfo() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { goBack } = useHistory()
  const [_deleteClientGroup, _setDeleteClientGroup] = useState(false)
  const { manageClientGroup, loading } = useSelector(all)

  const { adminEmail, adminName, id, name, retails, visible } =
    manageClientGroup

  const history = useHistory()

  useEffect(() => {
    history.replace({
      state: { nameBreadcrumbs: `${t('common:group')} ${name}` }
    })
  }, [history, name, id, t])

  function onExit() {
    _setDeleteClientGroup(false)
  }

  function onRemoveClientGroup() {
    dispatch(
      deleteClientGroup({
        id
      })
    )
    _setDeleteClientGroup(false)
    goBack()
  }

  function onDeleteClientGroup() {
    _setDeleteClientGroup(true)
  }

  return (
    <S.GridCard>
      {!loading && (
        <>
          <S.GridHeader>
            <S.GridTitle item container xs={12} md={6}>
              <S.BoxTitle>{t('common:customerGroup')}</S.BoxTitle>
            </S.GridTitle>
            <S.GridStatus item container xs={12} md={6}>
              <StatusBox variant={statusBadgeClassnames[String(visible)]}>
                {labels()[String(visible)]}
              </StatusBox>
            </S.GridStatus>
          </S.GridHeader>

          <S.Line />

          <S.GroupName>
            {t('common:group')} {name}
          </S.GroupName>
          <S.GroupTitle>{t('common:responsible')}</S.GroupTitle>
          <S.GroupTitleName>{adminName}</S.GroupTitleName>
          <S.GroupTitleEmail>{adminEmail}</S.GroupTitleEmail>

          <S.Line />

          <S.GridLinks>
            <Link to={`/grupo-cliente/editar/${id}`}>
              <S.Link>
                <Icon
                  icon={
                    theme.appTheme === THEMES_NAME.swift
                      ? 'group-profile-rename-swift'
                      : 'group-profile-rename'
                  }
                  height={16}
                  width={16}
                ></Icon>
                <span>{t('breadcrumb:editGroup')}</span>
              </S.Link>
            </Link>
            <S.Link onClick={onDeleteClientGroup}>
              <Icon
                icon={
                  theme.appTheme === THEMES_NAME.swift
                    ? 'group-profile-delete-swift'
                    : 'group-profile-delete'
                }
                height={16}
                width={16}
              ></Icon>
              <span>{t('breadcrumb:deleteGroup')}</span>
            </S.Link>
          </S.GridLinks>

          {_deleteClientGroup && (
            <ModalDeleteGroupClient
              groupName={name}
              retails={retails.length}
              onExit={onExit}
              onRemove={onRemoveClientGroup}
            />
          )}
        </>
      )}
    </S.GridCard>
  )
}
